import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import LoaderPreview from './LoaderPreview';
import LoaderControls from './LoaderControls';

const LoaderGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.LOADER]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.LOADER, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.LOADER, newConfig);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Loader Generator</h2>
      <LoaderControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const LoaderPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.LOADER]);
  return <LoaderPreview config={config} />;
};

export default LoaderGenerator;

